import {Assistant} from "./assistant";
import {functionCalls} from "../definitions/functionCalls";



export class OpenAiAssistant extends Assistant {
    constructor() {
        super();
    }

    override getApiUrl(): string {
        return 'https://localhost:7180/openai/chat';
    }

    override getGenerateImageUrl(): string {
        return 'https://localhost:7180/openai/generateImage';
    }

    override getEditImageUrl(): string {
        return 'https://localhost:7180/openai/editImage';
    }

    override getFunctionCalls(): any {
        return functionCalls;
    }

    override addSystemMessage(message) {
        const item = {
            "role": "system",
            "content": message
        };
        this.messages.push(item);
    }

    override addUserMessage(message) {
        const item = {
            "role": "user",
            "content": message
        };
        this.messages.push(item);
    }

    override addToolCall(functionId, functionName, functionArgs, functionResult) {
        this.requiredAnotherChat = true;

        const toolCall = {
            id: functionId,
            type: "function",
            function: {
                name: functionName,
                arguments: JSON.stringify(functionArgs)
            }
        };
        this.toolCalls.push(toolCall);

        const toolResult = {
                role: "tool",
                tool_call_id: functionId,
                name: functionName,
                content: functionResult
            };

        this.toolResults.push(toolResult);
    }


    override getFunctionList(result) {
        const functionList = result.choices.flatMap(choice => {
            if (choice.message.content != null) {
                const part = {
                    text: choice.message.content
                };
                return part;
            }
            return (choice.message.tool_calls || []).map(tc => {
                const part = {
                    functionCall : {
                        id: tc.id,
                        name: tc.function.name,
                        args: JSON.parse(tc.function.arguments)
                    }
                };
                return part;
            });
        });
        return functionList;
    }

    override getPrompt() {
        let messages = Array.from(this.messages);

        if (this.toolCalls.length > 0) {
            const toolCallMessage = {
                role: "assistant",
                tool_calls: this.toolCalls
            };
            messages.push(toolCallMessage);

            messages = messages.concat(this.toolResults);
        }

        const jsonPrompt = {
            "model": "gpt-4o",
            "temperature": 0,
            "messages": messages,
            "tools": this.getFunctionCalls(),
            tool_choice: "auto"
        };

        return jsonPrompt;
    }

}
